import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OperationsIndexComponent } from './operations-index/operations-index.component';
import { ProductConfig, PRODUCT_CONFIGS, COMMON_TOOLS } from './config/product.config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, OperationsIndexComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  readonly allProducts = Object.values(PRODUCT_CONFIGS);
  readonly commonTools = COMMON_TOOLS;
  isAuthenticated = false;
  currentProduct: ProductConfig = PRODUCT_CONFIGS.fiduciary;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly msal: MsalService,
    private readonly msalBroadcast: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    this.initializeAuthentication();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout(): void {
    this.msal.logoutRedirect();
  }

  private initializeAuthentication(): void {
    const activeAccount = this.msal.instance.getActiveAccount();

    if (activeAccount) {
      this.isAuthenticated = true;
      return;
    }

    this.waitForAuthenticationCompletion();
    this.msal.loginRedirect();
  }

  private waitForAuthenticationCompletion(): void {
    this.msalBroadcast.msalSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.msal.instance.getActiveAccount()) {
          this.isAuthenticated = true;
        }
      });
  }
}
